import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.displayOverlay)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 0,
          style: _normalizeStyle(_ctx.cardStyle),
          id: "tutorialCard",
          outlined: "",
          color: "primary"
        }, {
          default: _withCtx(() => [
            (_ctx.texts[_ctx.currentTextStep].img && _ctx.texts[_ctx.currentTextStep].outed)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  class: "g-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "1" }),
                    _createVNode(_component_v_col, {
                      cols: "10",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: _ctx.texts[_ctx.currentTextStep].img,
                          style: {"width":"170px","margin-top":"-50px"}
                        }, null, 8, ["src"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "1",
                      class: "d-flex justify-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          icon: "mdi-close",
                          size: "small",
                          onClick: _ctx.closeOverlay
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_ctx.texts[_ctx.currentTextStep].img)
                ? (_openBlock(), _createBlock(_component_v_img, {
                    key: 1,
                    width: "310",
                    src: _ctx.texts[_ctx.currentTextStep].img,
                    class: "d-flex justify-end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        icon: "mdi-close",
                        size: "small",
                        onClick: _ctx.closeOverlay
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["src"]))
                : _createCommentVNode("", true),
            _createVNode(_component_v_card_text, {
              class: "ma-0 pa-0",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, { color: "primary" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      class: "oss-list-item",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "11",
                              class: "font-weight-bold d-flex align-center subtitle-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.title), 1)
                              ]),
                              _: 1
                            }),
                            (!_ctx.texts[_ctx.currentTextStep].img)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  cols: "1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      icon: "mdi-close",
                                      size: "small",
                                      onClick: _ctx.closeOverlay
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "body-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.texts[_ctx.currentTextStep].text), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "d-flex justify-center align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_prev, {
                                  onClick: _ctx.previousStep,
                                  disabled: _ctx.disabledPevious,
                                  size: "small"
                                }, null, 8, ["onClick", "disabled"]),
                                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.currentTutorialStep) + "/" + _toDisplayString(_ctx.totalSteps), 1),
                                _createVNode(_component_v_btn_next, {
                                  onClick: _ctx.nextStep,
                                  size: "small"
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_overlay, {
      absolute: _ctx.displayOverlay,
      "z-index": 1000,
      class: "oss-overlay",
      style: _normalizeStyle(_ctx.overlayStyle),
      id: "tuto-overlay",
      modelValue: _ctx.displayOverlay,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.displayOverlay) = $event))
    }, null, 8, ["absolute", "style", "modelValue"])
  ]))
}